import {
  Component,
  OnInit,
  Optional,
  Inject,
  ViewChild,
  ElementRef,
  SecurityContext,
  OnDestroy,
} from '@angular/core';
import {
  MatDialogRef,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import { PaymentOptionsComponent } from 'src/app/common/components/payment-options/payment-options.component';
import { ApiService } from 'src/app/common/services/api.service';
import { MessageService } from 'src/app/common/services/message.service';
import { UtilService } from 'src/app/util/util.service';
import { ALLOWED_PLATFORM_CHANNEL_IDS } from 'src/app/order/platform.constant';
import { CurrencyService } from 'src/app/util/currency.service';
import { TranslateService } from '@ngx-translate/core';
import { FormaterService } from 'src/app/common/services/formater.service';
import { NzModalRef, NzModalService } from 'ng-zorro-antd/modal';
import { IframeComponent } from 'src/app/pos-order/modals/iframe/iframe.component';
import { Event as EventList, MType as MtypeList } from '../../pusher-event';
import { takeUntil } from 'rxjs/operators';
import { PusherEventService } from '../../common/services/pusher-event.service';
import { Subject, Subscription } from 'rxjs';
import { LocalStorageService } from 'src/app/common/services/localStorage.service';
import { CROSS, DUIT_NOW } from 'src/defaultImages.js';
import { PAYMENT_CHANNEL_ID, PaymentMethod } from 'src/app/common/enums/payment';
import { QRCodeService } from 'src/app/common/services/qr-code.service';
import { PaymentQRComponent } from 'src/app/pos-order/modals/payment-qr/payment-qr.component';
import { PaymentService } from 'src/app/common/services/payment.service';
import { PineLabDefaultChannel, PineLabsConsts, PineLabsEnum, PineLabsTimeOut } from 'src/app/common/enums/pinelabs.enum';
import { PineLabService } from 'src/app/common/services/pine-lab.service';
import { EventTrackerService } from 'src/app/common/services/event-tracker.service';
import { DomSanitizer } from '@angular/platform-browser';
import { BillingCountersDataService } from 'src/app/common/services/billing-counters-data.service';


@Component({
  selector: 'app-payment-pending',
  templateUrl: './payment-pending.component.html',
  styleUrls: ['./payment-pending.component.css'],
})
export class PaymentPendingComponent implements OnInit, OnDestroy {
  images = {
    CROSS: CROSS,
    DUIT_NOW: DUIT_NOW,
  };
  private ngUnsubscribe = new Subject();
  isKiosk;
  Currency;
  paymentAmount;
  token: string;
  billAmount: any;
  orderId: any;
  orderNo: any;
  isOngoingRequest = 0;
  translationText;
  currentPaymentMode: string;
  currentPaymentChannel: string;
  transcation_id: string;
  showCashColleted: boolean;
  recommendationArray = [];
  billBalance: any;
  amountToReturn: any;
  balanceStatus: boolean = false;
  onlinePaymentModal: NzModalRef;
  selectedAmount: number;
  platform: string;
  cashCollectedDetails: any = {};
  pusherForOnlinePaymentInitiated: boolean = false;
  @ViewChild('paymentOptionComponent', { static: false })
  paymentOption: PaymentOptionsComponent;
  qrData: string = '';
  isPaymentAmountInputDisabled: boolean =false;
  pineLabModal:any;
  pmtStatusModal:any;
  pusherForPineLabInitiated: boolean = false;
  isLoading:boolean = false;
  printDelay: number;
  isFCChangePaymentMethod: number = 0;
  fcOrderPayments: any = [];
  billingCounterName: string = '';
  billingCounterInfo: string = '';
  canTriggerKioskPrint:boolean = true;
  kioskPrintTimeout: ReturnType<typeof setTimeout>;
  restaurantId:string = '';
  subscription: Subscription = new Subscription();
  isOnlinePaymentLoading: boolean = false;
  constructor(
    public dialogRef: MatDialogRef<PaymentPendingComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    private apiService: ApiService,
    private messageService: MessageService,
    private utilService: UtilService,
    public translateService: TranslateService,
    private curr: CurrencyService,
    public format: FormaterService,
    private _modalService: NzModalService,
    private _pusherEvent: PusherEventService,
    private _localStorage: LocalStorageService,
    private _qrCodeService: QRCodeService,
    private _paymentService: PaymentService,
    private _pineLabService: PineLabService,
    private _eventTracker: EventTrackerService,
    private _sanitizer: DomSanitizer,
    private _counterDataService: BillingCountersDataService
  ) {
    this.Currency = this.curr.getCurrency();
    this.isKiosk = this.utilService.isKiosk();
    this.printDelay = this.utilService.getPrintDelay();
  }

  ngOnInit() {
    this.translateService.get(['ORDER_DASHBOARD']).subscribe((translation) => {
      this.translationText = translation.ORDER_DASHBOARD;
    });
    this.token = localStorage.getItem('token');
    this.billAmount = (this.data.isFCChangePaymentMethod && this.data?.fcOrderPayments?.length) ? Number(this.data.fcOrderPayments[0]?.paid_total) : Number(this.data.billamount);
    this.orderNo = this.data.orderno;
    this.orderId = this.data.orderid;
    this.platform = this.data.platform;
    this.isOngoingRequest = 0;
    // this.getAmountSuggestion(parseFloat(this.billAmount));
    this.isFCChangePaymentMethod = this.data.isFCChangePaymentMethod;
    this.fcOrderPayments = this.data?.fcOrderPayments;
    this.getBillingCounterName();
    this.restaurantId=this._localStorage.get('restaurant_id');
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
    this.subscription?.unsubscribe();
    clearTimeout(this.kioskPrintTimeout);
  }
  private getBillingCounterName(): void {
    this.subscription.add(
      this._counterDataService
        .getMappedBillingCounterName()
        .subscribe((mappedCounterName) => {
          this.billingCounterName = mappedCounterName;
          if (this.billingCounterName) {
            this.setSubHeading('PAYMENT_RECORDED');
          }
        })
    );

  }
  private setSubHeading(translationString: string): void {
    const counterSubHeading = this.translationText[translationString]?.replace(
      '{{billingCounterName}}',
      this.billingCounterName
    );
    this.sanitizeHtml(counterSubHeading);
  }
  private sanitizeHtml(html: string): void {
    this.billingCounterInfo = this._sanitizer.sanitize(
      SecurityContext.HTML,
      html
    );
  }
  watchPusherEvents() {
    /*Watching order  events on pusher*/
    this._pusherEvent
      .watchEvent(EventList.ORDER_EVENT)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((event) => this.onNewPusherEvent(event));
  }

  onNewPusherEvent(message) {
    this.messageService.showSuccess(`got pusher event, ${message.mtype}`);
    if (message.mtype === MtypeList.PAYMENT_SUCCESS) {
      const requiredStatus = [3, 4];
      this.apiService
        .getOrderDetailsNest(message.data.order_id)
        .subscribe((response: any) => {
          if (requiredStatus.includes(response.data.payment_status)) {
            if (this.onlinePaymentModal) {
              this.onlinePaymentModal.destroy({ data: 'success' });
            } else if(this.pineLabModal){
              const paymentsData = ((response.data || {}).bill || {}).payments || [];
              const paymentMethod = (Array.isArray(paymentsData) && paymentsData.length ) ? (paymentsData[paymentsData.length-1] || {}).payment_method :''; 
              this.pineLabModal.destroy({ data: PineLabsEnum.PAYMENT_SUCCESS,paymentMethod:paymentMethod });
            } else {
              this.messageService.showSuccess(
                this.translationText.PAYMENT_SUCCESSFUL
              );
              this.dialogRef.close({ data: 'success' });
            }
          }
        });
    }
    if (message.mtype === MtypeList.PAYMENT_FAILED) {
      this.messageService.showError(this.translationText.PAYMENT_FAILED);
    }
  }

  async initiateOnlinePayment(paymentMethod: string, callback: any) {
    if (this.isOnlinePaymentLoading) {
      return;
    }
    const {isFcUnpaidOrder, kioskFcOrderIds} = this.data;
    const params = this.utilService.getOnlinePaymentParams({
      paymentMethod: paymentMethod,
      orderId: this.orderId,
      isFcUnpaidOrder: isFcUnpaidOrder,
      childOrderIds: kioskFcOrderIds,
    });
    try {
      this.isOnlinePaymentLoading = true;
      const result = isFcUnpaidOrder
        ? await this._paymentService.initiateKioskOnlinePayment(params)
        : await this._paymentService.initiateOnlinePayment(params);
      if (result) {
        callback.call(this, result.paymentData);
      }
    } catch (error) {
      console.log(error);
    } finally {
      this.isOnlinePaymentLoading = false;
    }
  }

  regenerateQR() {
    this.qrData = ''
    this._qrCodeService.updateQRData(this.qrData);
    this.initiateOnlinePayment(
      PaymentMethod.duitnow,
      this.regenerateQRCallback
    );
  }

  openQRPage() {
    this.initiateOnlinePayment(PaymentMethod.duitnow, this.duitnowCallback);
  }

  openIframe() {
    this.initiateOnlinePayment(PaymentMethod.doku_qris, this.qrisCallback);
  }

  regenerateQRCallback(res: any) {
    this.qrData = res.data.qr_data;
    // Update the QR code in the QRCodeService
    this._qrCodeService.updateQRData(this.qrData);
  }

  duitnowCallback(res: any) {
    this.qrData = res.data.qr_data;
    this._qrCodeService.updateQRData(this.qrData);
    this.onlinePaymentModal = this._modalService.create({
      nzContent: PaymentQRComponent,
      nzTitle: `<div class="header-container"><img class="duit-now" src="${this.images.DUIT_NOW}" alt="Info" />
      <div class="sub-header">${this.translationText.QRIS_SUBHEADER}</div>
      </div>`,
      nzWrapClassName: 'ftue',
      nzBodyStyle: { "min-width": '65vw', width: 'auto', "max-width":"85vw", height: 'auto', 'max-height': '80vh', overflowY:'scroll' },
      nzFooter: null,
      nzClosable: false,
      nzComponentParams: {
        customCloseIcon: true,
        qrData: this.qrData,
        title: 'Duit now',
        regenerateQrHandler: this.regenerateQR.bind(this)
      },
    });
    this.modalServiceCallback();
  }

  qrisCallback(res: any) {
    this.onlinePaymentModal = this._modalService.create({
      nzContent: IframeComponent,
      nzTitle: `<div class="header-container">QRIS
      <div class="sub-header">${this.translationText.QRIS_SUBHEADER}</div>
      </div>`,
      nzWrapClassName: 'ftue',
      nzBodyStyle: { width: 'auto', height: 'auto' },
      nzFooter: null,
      nzComponentParams: {
        iframeSource: res.payment_page_url,
        title: 'QRIS',
      },
    });
    this.modalServiceCallback();
  }

  async openPaymentStatusPopUp(pmtStatus,amount,paymentMethod){
   this.pmtStatusModal = await this._pineLabService.commonPaymentStatusModal(pmtStatus,amount,paymentMethod);
   this.pmtStatusModal.afterClose.subscribe(() => {
    this.pmtStatusModal = null;
    this.dialogRef.close({ data: '' });
  });
 }

    // Payment Initiated for PineLab
    initiatePLPayment(orderId): void {
      const {isFcUnpaidOrder, kioskFcOrderIds} = this.data;
      try {
        this.isLoading = true;
        const pineLabPayload = this.utilService.getOnlinePaymentParams({paymentMethod: PaymentMethod.PINE_LABS, orderId: orderId, isFcUnpaidOrder: isFcUnpaidOrder, childOrderIds: kioskFcOrderIds});
        const initiateApi = isFcUnpaidOrder 
          ? this.apiService.initiateKioskPayment(pineLabPayload) 
          : this.apiService.initiatePLPayment(pineLabPayload);

          initiateApi.subscribe((res) => {
          this.isLoading = false;
          
          if (res) {
            if (res.data && res.data.pineLabsResponseCode === PineLabsConsts.SUCCESS) {
              this.openPineLabWaitingPopUp(
                orderId,
                res.data.pineLabsPtrId,
                res.data.invoice_number,
                res.data.amount
              );
            } else if (res.meta || res.http) {
              this.messageService.showError((res.meta || res.http).message);
            }
          }
        });
      } catch (error) { }
    }
  
    // waiting Payment popup for PineLab 
    async openPineLabWaitingPopUp(orderId:string,ptrId:string,pmtId:string,amount:number) {
       this.pineLabModal = await this._pineLabService.commonWaitingPaymentModal({
        orderId: orderId,
        ptrId:ptrId,
        pmtId:pmtId,
        amount:amount,
        mergedOrderArr:[],
        isSettleBillCall:false,
        isMaxiMize:false
      });
      if (!this.pusherForPineLabInitiated) {
        this.watchPusherEvents();
        this.pusherForPineLabInitiated = true;
      }
      this.pineLabModal.afterClose.subscribe((result: any = {}) => {
        this.pineLabModal = null;
        switch(result.data){
          case PineLabsEnum.PAYMENT_SUCCESS:
            this.openPaymentStatusPopUp(PineLabsEnum.PAYMENT_SUCCESS,amount,result.paymentMethod);
            break;
          case PineLabsEnum.PAYMENT_FAILED:
            this.messageService.showError(result.data);
            this.openPaymentStatusPopUp(PineLabsEnum.PAYMENT_FAILED,amount,'');
            break;
          case PineLabsEnum.PAYMENT_CANCELLED:
            this.messageService.showError(this.translationText.PAYMENT_CANCELED);
            this._pineLabService.removePLDataByOrderId(orderId,[],false);
            break;
          case PineLabsEnum.POP_UP_MINIMIZE:
            this.dialogRef.close({ data: '' }); 
            break;  
          case PineLabsTimeOut.EXPIRED:
            this.openTimeOutPopup(amount); 
            break;  
          }
      });
    }
   
    async openTimeOutPopup(amount){
     const timeOutModal = await this._pineLabService.commonTimeOutModal(amount);
     timeOutModal.afterClose.subscribe((result: any = {}) => {
         if(result==PineLabsTimeOut.RETRY){
         }else{
          this.dialogRef.close({ data: '' });
         }
    });
   } 

  modalServiceCallback() {
    if (!this.pusherForOnlinePaymentInitiated) {
      this.watchPusherEvents();
      this.pusherForOnlinePaymentInitiated = true;
    }
    this.onlinePaymentModal.afterClose.subscribe((result: any = {}) => {
      this.onlinePaymentModal = null;
      if (result.data === 'success') {
        this.messageService.showSuccess(
          this.translationText.PAYMENT_SUCCESSFUL
        );
        this.kioskPrint()
        return this.dialogRef.close({ data: 'success' });
      }
      this.apiService
        .getOrderDetailsNest(this.orderId)
        .subscribe((response: any) => {
          const requiredStatus = [3, 4];
          if (requiredStatus.includes(response.payment_status)) {
            this.messageService.showSuccess(
              this.translationText.PAYMENT_SUCCESSFUL
            );
            this.dialogRef.close({ data: 'success' });
          }
        });
    });
  }

  cancel_clicked() {
    this.dialogRef.close({ data: 'closed' });
  }
  paymentName(e) {
    this.currentPaymentMode = e;
    if (this.currentPaymentMode == 'Cash') this.showCashColleted = true;
    else this.showCashColleted = false;
  }

  paymentChannel(e) {
    this.currentPaymentChannel = e;
  }
  openDrawerOnDevice() {
    this.utilService.send_dkick_code_to_react(
      localStorage.getItem('dkick_code'),
      localStorage.getItem('restaurant_printer')
        ? localStorage.getItem('restaurant_printer')
        : 'Default Printer',
      this.orderId,
      ''
    );
    this.utilService.openCashDrawer();
  }
  transactionIdChange(e) {
    this.transcation_id = e;
  }
  amountPaid(e) {
    this.paymentAmount = e;
  }
  paymentDoneClicked() {
    if (this.currentPaymentChannel === 'cash') {
      this.openDrawerOnDevice();
    }
    if (
      this.currentPaymentChannel === 'offline_union_experience_voucher' ||
      ALLOWED_PLATFORM_CHANNEL_IDS.includes(this.currentPaymentChannel)
    ) {
      for (const i in this.paymentOption.unionExperienceForm.controls) {
        this.paymentOption.unionExperienceForm.controls[i].markAsDirty();
        this.paymentOption.unionExperienceForm.controls[
          i
        ].updateValueAndValidity();
      }
      if (!this.paymentOption.unionExperienceForm.valid) {
        return;
      }
    }
      if (this.currentPaymentChannel === PAYMENT_CHANNEL_ID.QRIS_CHANNEL_ID) {
        this.openIframe();
      }else if(this.currentPaymentChannel === PAYMENT_CHANNEL_ID.DUITNOW_CHANNEL_ID){
        this.openQRPage();
      }else if(this.currentPaymentChannel === PineLabDefaultChannel.PAYMENT_CHANNEL){
        if(!this.isLoading ){
          this.initiatePLPayment(this.orderId);
        }
      }
       else {
        this.mark_cash_collected(this.data.order_id);
      }
  }

  createPayload(formData) {
    const object = {};
    formData.forEach((value, key) => {
      if (['collected_amt','is_kiosk_change_payment_method'].includes(key)) {
        object[key === 'collected_amt' ? 'collected_amount': key] = +value;
      } else {
        object[key] = value;
      }
    });
    object['kiosk_restaurant_id'] = this._localStorage.get('restaurant_id');
    const json = JSON.stringify(object);
    return json;
  }
  
  private kioskPrint(){
    if (
      this.isKiosk &&
      this.data.kioskFcOrderIds.length &&
      this.utilService.isPrinterEnabled()
    ) {
      try{
        if(this.canTriggerKioskPrint){
          this.canTriggerKioskPrint = false;
          this.utilService.sendFinalPrintCommand(this.data?.kioskFcOrderIds?.[0]);
          this.kioskPrintTimeout = setTimeout(() => {
            this.canTriggerKioskPrint = true;
          }, 3000);
        } 
      }catch(error){
        this.canTriggerKioskPrint = true;
        console.error(error);
      }
    }
  }

  kioskCashCollection(order_id) {
      this.isOngoingRequest = 1;
      const formData: any = new FormData();
      formData.append('kiosk_order_no', this.data.kiosk_order_no);
      formData.append('staff_name', this._localStorage.get('user_name'));
      formData.append('is_kiosk_change_payment_method',+this.isFCChangePaymentMethod);
      this.currentPaymentChannel !== 'cash' &&
        this.paymentAmount &&
        formData.append(
          'collected_amt',
          +this.format.formatMy(this.paymentAmount)
        );
      formData.append('fc_order_id', this.orderId);
      formData.append('payment_channel', this.currentPaymentChannel);
      this.currentPaymentChannel !== 'offline_union_experience_voucher' &&
        formData.append('orderids', JSON.stringify([]));
      formData.append(
        'transaction_id',
        this.currentPaymentChannel === 'offline_union_experience_voucher' ||
          ALLOWED_PLATFORM_CHANNEL_IDS.includes(this.currentPaymentChannel)
          ? this.paymentOption.unionExperienceForm.value.txn_id
          : this.transcation_id
      );
      (this.currentPaymentChannel === 'offline_union_experience_voucher' ||
        ALLOWED_PLATFORM_CHANNEL_IDS.includes(this.currentPaymentChannel)) &&
        formData.append(
          'collected_amt',
          +this.format.formatMy(
            this.paymentOption.unionExperienceForm.value.amount
          )
        );
      if (
        this.cashCollectedDetails &&
        this.cashCollectedDetails.collected_amt &&
        this.cashCollectedDetails.returned_amt
      ) {
        this.currentPaymentChannel === 'cash' &&
          formData.append(
            'collected_amt',
            +this.format.formatMy(this.cashCollectedDetails.collected_amt)
          );
        formData.append(
          'returned_amt',
          +this.format.formatMy(this.cashCollectedDetails.returned_amt)
        );
      }
      if (
        this.isKiosk &&
        this.cashCollectedDetails &&
        this.cashCollectedDetails.collected_amt &&
        this.currentPaymentChannel === 'cash'
      ) {
        formData.append(
          'collected_amt',
          +this.format.formatMy(this.cashCollectedDetails.collected_amt)
        );
      }
      formData.append('device_id', this.utilService.getDeviceUID());
      const payload = this.createPayload(formData);
      this.apiService
        .cashCollectedKiosk(payload)
        .pipe((res) => res)
        .subscribe(
          (res) => {
            if (
              (res.status || {}) == 1 ||
              ((res.statusCode || {}) === 201 && (res.data || {}).status !== 0)
            ) {
              this.messageService.showSuccess(
                this.translationText.PAYMENT_COLLECTED_SUCCESSFULLY
              );
              if (this.currentPaymentMode !== 'Cash') {
                this.billAmount =
                  this.billAmount.toFixed(2) -
                  this.format.formatMy(this.paymentAmount);
                if (!this.paymentAmount)
                  this.dialogRef.close({ data: 'success' });
              } else {
                this.billAmount =
                  this.billAmount.toFixed(2) -
                  this.format.formatMy(this.cashCollectedDetails.collected_amt);
                if (!this.cashCollectedDetails.collected_amt)
                  this.dialogRef.close({ data: 'success' });
              }

              if (this.billAmount === 0) {
                this.dialogRef.close({ data: 'success' });
              }
              // Print final bill for each order incase of kiosk orders
              this.kioskPrint()
            } else {
              if ((res.data || {}).status === 0) {
                this.messageService.showError((res.data || {}).message);
              } else {
                this.messageService.showError((res || {}).message);
              }
              this.dialogRef.close({ data: 'failed' });
            }
            this.isOngoingRequest = 0;
          },
          (error) => {
            this.isOngoingRequest = 0;
            this.messageService.showError(
              (error.error || {}).message ||
                this.translationText.SOMETHING_WENT_WRONG_PLEASE_TRY_AGAIN_LATER
            );
          }
        );
  }
  cashCollected(order_id) {
    this.isOngoingRequest = 1;
    const payload = {
      orderId: this.orderId,
      paymentChannel: this.currentPaymentChannel,
    };
    if (this.currentPaymentChannel !== 'cash' && this.paymentAmount) {
      payload['collectedAmt'] = +this.format.formatMy(
        this.paymentAmount
      );
    }
    if (
      this.currentPaymentChannel !== 'offline_union_experience_voucher'
    ) {
      payload['orderIds'] = [];
    }
    payload['transactionId'] =
      this.currentPaymentChannel === 'offline_union_experience_voucher' ||
      ALLOWED_PLATFORM_CHANNEL_IDS.includes(this.currentPaymentChannel)
        ? this.paymentOption.unionExperienceForm.value.txn_id
        : this.transcation_id;
    if(this.currentPaymentChannel === 'offline_union_experience_voucher' ||
      ALLOWED_PLATFORM_CHANNEL_IDS.includes(this.currentPaymentChannel)){
        payload['collectedAmt'] = +this.format.formatMy(
          this.paymentOption.unionExperienceForm.value.amount
        )
      }
      if (
        this.cashCollectedDetails &&
        this.cashCollectedDetails.collected_amt &&
        this.cashCollectedDetails.returned_amt
      ){
        if(this.currentPaymentChannel === 'cash'){
          payload['collectedAmt'] = +this.format.formatMy(this.cashCollectedDetails.collected_amt);
        }
        payload['returnedAmt'] = +this.format.formatMy(this.cashCollectedDetails.returned_amt);
      }
      payload['deviceId'] = this.utilService.getDeviceUID();
    this.apiService.cashCollectedNest(payload)
        .pipe((res) => res)
        .subscribe(
          (res) => {
            if (
              res?.data?.status
            ) {
              this.messageService.showSuccess(
                this.translationText.PAYMENT_COLLECTED_SUCCESSFULLY
              );
              if (this.currentPaymentMode !== 'Cash') {
                this.billAmount =
                  this.billAmount.toFixed(2) -
                  this.format.formatMy(this.paymentAmount);
                if (!this.paymentAmount)
                  this.dialogRef.close({ data: 'success' });
              } else {
                this.billAmount =
                  this.billAmount.toFixed(2) -
                  this.format.formatMy(this.cashCollectedDetails.collected_amt);
                if (!this.cashCollectedDetails.collected_amt)
                  this.dialogRef.close({ data: 'success' });
              }

              if (this.billAmount === 0) {
                this.dialogRef.close({ data: 'success' });
              }
            } else {
              if (res.data?.status === 0) {
                this.messageService.showError(res?.data?.message);
              }
              this.dialogRef.close({ data: 'failed' });
            }
            this.isOngoingRequest = 0;
          },
          (error) => {
            this.isOngoingRequest = 0;
            this.messageService.showError(
              error?.error?.message ||
                this.translationText.SOMETHING_WENT_WRONG_PLEASE_TRY_AGAIN_LATER
            );
          }
        );
  }

  mark_cash_collected(order_id) {
    if (this.isOngoingRequest == 1) {
      // this.message.info('collecting cash! please wait');
    } else {
      if (this.isKiosk) {
        this.kioskCashCollection(order_id);
      } else {
        this.cashCollected(order_id);
      }

      this._eventTracker.easyeat_track_event('PAYMENT_SETTLED_POS', {
        BILL_TOTAL: this.billAmount,
        ORDER_ID: order_id,
        Payment_Method: this.currentPaymentChannel,
        TRANSACTION_ID: this.transcation_id,
      });
    }
  }
  cashTransactionDetail(e) {
    this.cashCollectedDetails = e;
  }
}
